import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./Header.css";
import navLinks from "../data/navLinks";

const Header = ({ title, subtitle, onLangChange, lang, meta }) => {
  const [darkMode, setDarkMode] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem("darkMode") === "true";
    }
    return false;
  });

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const navigate = useNavigate();

  const handleToggleDarkMode = () => {
    const newValue = !darkMode;
    setDarkMode(newValue);
    localStorage.setItem("darkMode", newValue);
  };

  const handleSearchChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    if (term.trim()) {
      const suggestions = navLinks.filter(link =>
        link.label.toLowerCase().includes(term.toLowerCase())
      );
      setFilteredSuggestions(suggestions);
    } else {
      setFilteredSuggestions([]);
    }
  };

  const handleSelectSuggestion = (to) => {
    setSearchTerm("");
    setFilteredSuggestions([]);
    navigate(to);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const match = navLinks.find(link =>
      link.label.toLowerCase() === searchTerm.toLowerCase()
    );
    if (match) handleSelectSuggestion(match.to);
  };

  useEffect(() => {
    document.body.classList.toggle("dark", darkMode);
  }, [darkMode]);

  return (
    <>
      <Helmet>
        <title>{meta?.title || title}</title>
        <meta name="description" content={meta?.description || subtitle} />
        {meta?.keywords && <meta name="keywords" content={meta.keywords} />}
        {meta?.author && <meta name="author" content={meta.author} />}
      </Helmet>

      <header className="header">
        <div className="header-left">
          <Link to="/" className="logo-wrapper">
            <img src="/logo.png" alt="Logo" className="logo-img" />
          </Link>
          <div className="header-text">
            <h1 id="title">{title}</h1>
            <p id="subtitle">{subtitle}</p>
          </div>
        </div>
        <div className="header-controls">
          <div className="search-box">
            <form onSubmit={handleSearchSubmit}>
              <input
                type="text"
                value={searchTerm}
                onChange={handleSearchChange}
                placeholder="Search tools..."
                className="search-input"
              />
            </form>
            {filteredSuggestions.length > 0 && (
              <ul className="suggestions-list">
                {filteredSuggestions.map((item) => (
                  <li key={item.to} onClick={() => handleSelectSuggestion(item.to)}>
                    {item.label}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className="header-actions">
            {/* <Link to="/blog" className="top-link blog-link" style={{ marginRight: "1rem" }}>Blog</Link> */}
            <select id="language" value={lang} onChange={(e) => onLangChange(e.target.value)}>
              <option value="en">English</option>
            </select>
            <button onClick={handleToggleDarkMode}>{darkMode ? "☀️" : "🌙"}</button>
          </div>
        </div>
      </header>

      {/* <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
        <div className="dropdown">
          <button className="dropdown-toggle" onClick={() => setDevOpen(!devOpen)}>
            Developer Tools ▾
          </button>
          {devOpen && (
            <div className="dropdown-content">
              {allLinks.filter(link => link.type === "dev").map(link => (
                <Link key={link.to} to={link.to} onClick={() => setMenuOpen(false)}>
                  {link.label}
                </Link>
              ))}
            </div>
          )}
        </div>

        <div className="dropdown">
          <button className="dropdown-toggle" onClick={() => setConvertOpen(!convertOpen)}>
            Convert Tools ▾
          </button>
          {convertOpen && (
            <div className="dropdown-content">
              {allLinks.filter(link => link.type === "convert").map(link => (
                <Link key={link.to} to={link.to} onClick={() => setMenuOpen(false)}>
                  {link.label}
                </Link>
              ))}
            </div>
          )}
        </div>
      </nav> */}
    </>
  );
};

export default Header;